<ps-ui-header
  (closeSurvey)="goToDashboard($event)"
  (openServiceAccountModal)="selectBuyer($event)"
  (openMultiBuyerModal)="selectMultiBuyer()"
  [isLaunchSurvey]="true"
  [canSwitchUi]="canSwitchUi"
  (switchUi)="switchToPhoenix()"
></ps-ui-header>
<ps-ui-survey-launch [surveyId]="surveyId" [auth]="auth"></ps-ui-survey-launch>
